/**
 * @generated SignedSource<<8fc65b6eff688cd8413bc031128c2ebf>>
 * @lightSyntaxTransform
 * @nogrep
 */
const node = {
    "argumentDefinitions": [],
    "kind": "Fragment",
    "metadata": null,
    "name": "ScheduleSwitch_user",
    "selections": [
        {
            "alias": null,
            "args": null,
            "concreteType": "SchedulableUser",
            "kind": "LinkedField",
            "name": "schedulableEntity",
            "plural": false,
            "selections": [
                {
                    "alias": null,
                    "args": null,
                    "kind": "ScalarField",
                    "name": "id",
                    "storageKey": null
                },
                {
                    "alias": null,
                    "args": null,
                    "kind": "ScalarField",
                    "name": "schedulable",
                    "storageKey": null
                }
            ],
            "storageKey": null
        }
    ],
    "type": "User",
    "abstractKey": null
};
node.hash = "f33236c132425a09cdff343692a828c5";
export default node;
